import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeString } from '@ipensii/shared/domain-shared';

@Pipe({
  name: 'ipSharedFormatDateTime',
  standalone: true,
})
export class FormatDateTimePipe implements PipeTransform {
  transform(dateTime: DateTimeString, locale?: string): unknown {
    return dateTime
      ? Intl.DateTimeFormat(locale || navigator.language, {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        }).format(new Date(dateTime))
      : null;
  }
}
